<template>
  <div class="table-responsive pb-3">
    <!-- <div class="my-3">
      <div class="pt-3">
        <form id="search" class="row"></form>
      </div>
      <slot name="button"></slot>
    </div> -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card
        :min-width="400"
        style="justify-content: center; display: flex; flex-wrap: wrap"
      >
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          right
          absolute
          ripple
          @click="dialog = false"
          style="outline: none"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>

        <v-card-title style="margin-top: 25px"
          >Combien de jours vouler vous rétablir au solde de l'employé ?
          <div v-show="false">{{ deleteBtn.numberOfDays }}</div>
          <v-text-field
            v-model="deleteBtn.numberOfDays"
            placeholder="Nombre de jours"
            solo
          ></v-text-field>
        </v-card-title>
        <v-card-actions>
          <v-btn
            @click.prevent="click(deleteBtn.action_yes, deleteBtn.numberOfDays)"
            >Oui</v-btn
          >
          <v-btn @click.prevent="click(deleteBtn.action_no)">Non</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <table class="custom-table table t-responsive">
      <thead class="t-header-color">
        <tr class="text-center">
          <th
            v-for="(key, index) in orderedColumns"
            :class="{ active: sortKey === key }"
            v-bind:key="index"
          >
            <span class="cursor-pointer" @click="sortBy(key)">{{
              key | capitalize
            }}</span>
            <span
              v-if="isSortable(key)"
              class="arrow cursor-pointer"
              @click="sortBy(key)"
              :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"
            ></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, index) in filteredData" v-bind:key="'th' + index">
          <td v-for="(key, i2) in orderedColumns" v-bind:key="'td' + i2">
            <template v-if="key == 'Action'">
              <div v-for="(btn, index) in entry[key]" :key="index">
                <div v-if="btn.component === undefined"></div>
                <button
                  v-else-if="btn.content == 'Annuler'"
                  :class="btn.class"
                  class="btn btn-sm"
                  :disabled="btn.disabled"
                  style="font-size: 10px; width: 106px"
                  @click="setDeleteBtn(btn)"
                >
                  <i v-if="btn.icon" :class="btn.icon"></i>
                  {{ btn.content }}
                </button>
                <button-td v-else :value="btn"></button-td>
              </div>
            </template>
            <template v-else-if="isComponent(entry[key])">
              <link-td
                v-if="entry[key].component === 'link-td'"
                :value="entry[key]"
              ></link-td>
              <button-td
                v-else-if="entry[key].component === 'button-td'"
                :value="entry[key]"
              ></button-td>
              <html-td
                v-else-if="entry[key].component === 'html-td'"
                :value="entry[key]"
              ></html-td>
              <checkbox-td
                v-else-if="entry[key].component === 'checkbox-td'"
                :value="entry[key]"
              ></checkbox-td>
            </template>
            <template v-else>
              <div v-if="key === 'Responsables'">
                <div v-for="(item, i) in entry[key]" :key="`name-${i}`">
                  {{ item.firstName }} {{ item.lastName }}
                </div>
              </div>
              <div
                :data-title="entry[key].firstName + entry[key].lastName"
                v-else-if="key === 'Nom et prénom'"
              >
                {{
                  `${entry[key].firstName} ${entry[key].lastName}`.length > 15
                    ? `${entry[key].firstName} ${entry[key].lastName}`.slice(
                        0,
                        15
                      ) + "..."
                    : `${entry[key].firstName} ${entry[key].lastName}`
                }}
              </div>
              <div v-else-if="key == 'Type de contrat'">
                <span class="type-de-contrat">
                  {{ entry[key] }}
                </span>
              </div>
              <div v-else-if="key == 'Type de contrats'">
                <span class="type-de-contrat ml-2" v-for="typeContract in entry[key]">
                  {{ contractType[typeContract].name }}
                </span>
              </div>
              <div v-else-if="key !== 'Statut'">{{ entry[key] }}</div>
  
              <div v-else>
                <button
                  v-if="entry[key] === 'ACCEPTED'"
                  class="status-pill-accepted"
                >
                  <span>Régie approuvée</span>
                </button>
                <button
                  v-else-if="entry[key] === 'REFUSED'"
                  class="status-pill-rejected"
                >
                  <span>Régie rejetée</span>
                </button>
                <button
                  v-else-if="entry[key] === 'TREATED'"
                  class="status-pill-approved"
                >

                  <span>Régie enregistrée</span>
                </button>
                <button
                  v-else-if="entry[key] === 'MODIFIED'"
                  class="status-pill-modified"
                >
                  <span>Demande de modifications</span>
                </button>
                <button v-else class="status-pill-pending">
                  <span>Régie en cours de traitement</span>
                </button>
                <div v-if="entry['Action nécéssaire'] == true">
                  <button
                    class="mt-3 status-pill-action"
                  >
                    <span>Action nécéssaire</span>
                  </button>
                </div>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example text-center" class="pl-4">
      <ul class="pagination">
        <li class="page-item" v-if="tableState.page > 1">
          <a class="page-link" href="#" @click.prevent="previousPage">{{
            $t("data.table.previous")
          }}</a>
        </li>
        <template v-for="(index, i) in displayedPaged">
          <li
            v-bind:key="index"
            class="page-item"
            v-bind:class="{ active: index === tableState.page }"
          >
            <a class="page-link" href="#" @click.prevent="setPage(index)">{{
              index
            }}</a>
          </li>
          <li
            v-if="
              displayedPaged.length > i + 1 && displayedPaged[i + 1] > index + 1
            "
            v-bind:key="index + 'dot'"
          >
            <a class="page-link" href="#">...</a>
          </li>
        </template>
        <li class="page-item" v-if="tableState.page < pageNum">
          <a class="page-link" href="#" @click.prevent="nextPage">{{
            $t("data.table.next")
          }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import LinkTd from "../dataTable/linkTd.vue";
import ButtonTd from "../dataTable/buttonTd.vue";
import HtmlTd from "../dataTable/htmlTd.vue";
import CheckboxTd from "../dataTable/checkboxTd.vue";
import contractType from "../../data/contract/contractType";

export default {
  name: "dataTable",
  components: {
    CheckboxTd,
    HtmlTd,
    ButtonTd,
    LinkTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    pagination: Array,
    selectedFields: Array,
    tableState: Object,
    count: Number,
    maxPage: Number,
    fieldsGrid: Array,
  },
  data() {
    const sortOrders = {};
    const tableState = this.tableState;
    this.selectedFields.forEach((key) => {
      if (key === tableState.field && tableState.ascending === false) {
        sortOrders[key] = -1;
      } else {
        sortOrders[key] = 1;
      }
    });
    return {
      sortKey: this.tableState.field ? this.tableState.field : "",
      sortOrders,
      filterKey: "",
      orderedColumns: [],
      dialog: false,
      deleteBtn: {},
      contractType,
    };
  },

  computed: {
    pageNum() {
      const pageNum = Math.ceil(this.count / this.tableState.perPage);
      if (this.maxPage) {
        return pageNum > this.maxPage ? this.maxPage : pageNum;
      }
      return pageNum;
    },

    displayedPaged() {
      const displayedPaged = new Set();
      for (let i = 1; i <= this.pageNum && i <= 5; i++) {
        displayedPaged.add(i);
      }
      for (
        let i = this.tableState.page - 4;
        i <= this.tableState.page + 10;
        i++
      ) {
        if (i > 0 && i <= this.pageNum) {
          displayedPaged.add(i);
        }
      }
      displayedPaged.add(this.pageNum);
      return [...displayedPaged];
    },

    filteredData() {
      const filterKey = this.filterKey && this.filterKey.toLowerCase();
      let data = this.data;

      if (filterKey) {
        data = data.filter((row) =>
          Object.keys(row).some((key) => {
            if (row[key] instanceof Object) {
              if (row[key].content) {
                return (
                  String(row[key].content).toLowerCase().indexOf(filterKey) > -1
                );
              }
            } else {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
            }
          })
        );
      }
      return data;
    },
  },
  filters: {
    capitalize(str) {
      if (str instanceof String) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
      return str;
    },
  },

  mounted() {
    this.orderedColumns = this.selectedFields;
  },

  methods: {
    setDeleteBtn(btn) {
      this.deleteBtn = btn;
      this.dialog = true;
    },
    click(method, number) {
      this.dialog = false;
      if (number) {
        method(number);
      }
      method();
    },
    changePerPage() {
      this.tableState.page = 1;
    },
    isSortable(key) {
      const field = this.fieldsGrid.find((f) => f.title === key);
      if (field !== undefined && field.value.length === 0) {
        return false;
      }
      return true;
    },
    sortBy(key) {
      if (this.isSortable(key)) {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
        this.tableState.ascending = this.sortOrders[key] > 0;
        this.tableState.field = key;
      }
    },
    setPage(page) {
      this.tableState.page = page;
    },
    nextPage() {
      if (this.tableState.page < this.pageNum) {
        this.tableState.page++;
      }
    },
    previousPage() {
      if (this.tableState.page > 1) {
        this.tableState.page--;
      }
    },
    isComponent(value) {
      return value instanceof Object && value.component;
    },
  },
};
</script>

<style lang="scss" scoped>
ul.pagination {
  display: flex;
  justify-content: center;
}
#search {
  margin-bottom: 10px;
  font-size: 1rem;
  .table-query {
    margin-right: 10px;
  }
}
.t-header-color {
  background-color: #2571c1;
  tr {
    th {
      border: 0 !important;
      color: #fff;
    }
  }
}
.tick-icon {
  width: 25px;
  text-align: center;
}
.text-label {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 0.5rem;
  margin: 0;
  @media (max-width: 576px) {
    padding-top: 12px;
    padding-left: 2px;
  }
}

.page-item {
  &.active {
    color: #007bff;
  }
}

.small-select {
  width: 100px;
  margin-right: 10px;
}
.table-result-text {
  padding-top: 35px;
}

th {
  color: gray;

  &.active {
    color: #007bff;

    .arrow {
      opacity: 1;

      &.asc {
        border-bottom: 4px solid #007bff;
      }

      &.dsc {
        border-top: 4px solid #fff;
      }
    }
  }
}

td {
  text-align: center;
  vertical-align: middle !important;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
  color: black;

  &.asc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #fff;
  }

  &.dsc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #fff;
  }
}
@media (max-width: 576px) {
  .t-responsive {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-result-text {
    padding-left: 20px !important;
  }
}

input {
  outline: none;
  -moz-appearance: none;
  box-shadow: none !important;
  -webkit-appearance: none;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.custom-table thead tr th {
  background-color: #fbfbfb;
  color: #303778;
}
.custom-table tbody tr {
  // background-color: #e9ecef;
  // color: #303778;
  border-bottom: 1px solid #e9ecef;
}

.status-pill-modified {
  border: 1px solid #78756D;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-modified span {
  display: block;
  width: 150px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: #E0DFDD;
  color: #78756D;
}
.status-pill-pending {
  border: 1px solid #ffb400;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-pending span {
  display: block;
  width: 150px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: rgba(255, 180, 0, 0.24);
  color: #ffb400;
}
.status-pill-approved {
  border: 1px solid #17c671;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-approved span {
  display: block;
  width: 150px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: rgba(23, 198, 113, 0.24);
  color: #17c671;
}
.status-pill-accepted {
  border: 1px solid #174BC6;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-accepted span {
  display: block;
  width: 150px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: #C6E0FA;
  color: #174BC6;
}
.status-pill-rejected {
  border: 1px solid #c4183c;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-rejected span {
  display: block;
  width: 150px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: rgba(196, 24, 60, 0.24);
  color: #c4183c;
}
.status-pill-action {
  border: 1px solid #6200EF;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-action span {
  display: block;
  width: 100px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: #6400ef34;
  color: #6200EF;
}
[data-title] {
  font-size: 12px;
  position: relative;
}
[data-title]:hover::before {
  content: attr(data-title);
  position: absolute;
  bottom: -46px;
  padding: 10px;
  background: #000;
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
}

.type-de-contrat {
  background-color: #F6F8FF;
  color: #0077FF;
  padding: 7px;
  border-radius: 7px;
}

</style>
